import React from "react";
import PropTypes from "prop-types";
import { Field } from "redux-form";
import { AutoCompleteField } from "MODULES/shared/components/Forms";

export default function BuyerField({
  disabled = false,
  label = "Buyer",
  name = "buyer_id",
  onItemSelected = () => {},
  required = true,
  searchBuyers,
  selectedBuyer
}) {
  return (
    <Field
      name={name}
      disabled={disabled}
      label={label}
      placeholder="Search by name..."
      component={AutoCompleteField}
      search={searchBuyers}
      selectedItem={selectedBuyer}
      onItemSelected={onItemSelected}
      formatItem={result => result && result.full_name}
      required={required}
    />
  );
}

BuyerField.propTypes = {
  disabled: PropTypes.bool,
  name: PropTypes.string,
  label: PropTypes.string,
  onItemSelected: PropTypes.func,
  required: PropTypes.bool,
  searchBuyers: PropTypes.func.isRequired,
  selectedBuyer: PropTypes.instanceOf(Object)
};



// WEBPACK FOOTER //
// ./app/modules/PurchaseOrders/shared/CoBuyersFields/BuyerField.jsx